<template>
  <v-dialog v-model="dialog" max-width="450" persistent overlay-color="var(--tx)" overlay-opacity="0.4">
    <v-card class="rounded-xl overflow-hidden shadow-premium">
      <div class="pa-6 pb-0">
        <div class="d-flex align-center mb-1">
          <div class="icon-wrap mr-3">
            <v-icon color="var(--brand)">mdi-tag-plus-outline</v-icon>
          </div>
          <div class="d-flex flex-column">
            <span class="dialog-title">Add Category</span>
            <span class="dialog-subtitle">Create a new expense category</span>
          </div>
        </div>
      </div>

      <v-card-text class="pa-6 mt-4">
        <div class="premium-field-label mb-2">Category Name *</div>
        <v-text-field
          v-model="category.name"
          name="name"
          placeholder="e.g. Utility Bills, Maintenance"
          outlined
          dense
          hide-details="auto"
          class="premium-dialog-input"
          v-validate="'required'"
          :error="errors.first('name') || serverSideErrors.name"
        />
        <div class="error-text" v-if="errors.first('name') || serverSideErrors.name">
          {{ errors.first('name') || serverSideErrors.name }}
        </div>
      </v-card-text>

      <div class="dialog-actions pa-6">
        <v-btn text class="btn-premium-cancel" @click="closeDialog">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          depressed
          class="btn-premium-primary ml-3"
          :loading="loading"
          @click="saveCategory"
        >
          Submit
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  props: {
    dialog: { type: Boolean, default: false },
    categories: { type: Array, default: () => [] },
  },
  data() {
    return {
      category: { name: "" },
      serverSideErrors: {},
      loading: false,
    };
  },
  methods: {
    ...mapMutations('alert', ['setAlert']),
    closeDialog() {
      this.$emit('update:dialog', false);
      this.$validator.reset();
      this.category = { name: "" };
    },
    saveCategory() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true;
          this.$axios.post('societyadmin/categories', { name: this.category.name }).then((response) => {
            this.loading = false;
            const data = response.data;
            if (data.status) {
              this.setAlert({
                showAlert: true,
                variant: 'green accent-4',
                timeout: 2000,
                message: data.message,
              });
              this.$emit('category-added', data.category);
              this.closeDialog();
            } else {
              this.serverSideErrors = {};
              if (data.errors) {
                data.errors.forEach((error) => {
                  this.serverSideErrors[error.field] = error.message;
                });
              } else {
                this.setAlert({
                  showAlert: true,
                  message: data.message,
                  variant: 'red accent-3',
                  timeout: 2000,
                });
              }
            }
          }).catch(() => { this.loading = false; });
        }
      });
    },
  },
};
</script>

<style scoped>
.dialog-title {
  font-family: 'Bricolage Grotesque', sans-serif;
  font-size: 20px;
  font-weight: 800;
  color: var(--tx);
  letter-spacing: -0.02em;
}
.dialog-subtitle { font-size: 13px; color: var(--tx3); }

.icon-wrap {
  width: 42px; height: 42px;
  background: var(--surface2);
  border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
}

.premium-field-label {
  font-size: 12px;
  font-weight: 700;
  color: var(--tx3);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

::v-deep .premium-dialog-input .v-input__slot {
  border-radius: 12px !important;
  background: var(--surface2, #F8FAFC) !important;
  border: 1px solid var(--border, #E2E8F0) !important;
}
::v-deep .premium-dialog-input fieldset { border: none; }

.dialog-actions { display: flex; align-items: center; border-top: 1px solid var(--border); }
.cancel-btn { text-transform: none; font-weight: 600; color: var(--tx2); border-radius: 10px; }
.save-btn { border-radius: 10px !important; text-transform: none; font-weight: 700; color: white !important; }

.error-text { font-size: 12px; color: #EF4444; margin-top: 4px; font-weight: 500; }
</style>